import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { Loader2, ArrowRight } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center container-px py-24" data-testid="login-page">
      <div aria-hidden className="fixed inset-0 grid-noise opacity-60 pointer-events-none -z-10" />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex mb-10"><Logo /></Link>
        <div className="glass-card p-8">
          <div className="eyebrow text-gold-300">Welcome back</div>
          <h1 className="mt-2 font-serif text-3xl text-white">Login to AIBoxHub</h1>
          <p className="mt-2 text-sm text-white/55">Access your client dashboard, subscriptions and AI workspace.</p>

          <form onSubmit={submit} className="mt-7 space-y-4">
            <Input testId="login-email" label="Email" type="email" value={email} onChange={setEmail} required />
            <Input testId="login-password" label="Password" type="password" value={password} onChange={setPassword} required />
            {error && <div className="text-sm text-red-400" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="w-full pill pill-gold justify-center disabled:opacity-50" data-testid="login-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Sign in <ArrowRight className="h-4 w-4" /></>}
            </button>
          </form>

          <div className="mt-6 text-sm text-white/55">
            New to AIBoxHub?{" "}
            <Link to="/register" className="text-gold-300 hover:text-gold-200" data-testid="login-to-register">Create an account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type = "text", required, testId }) {
  return (
    <div>
      <div className="mb-1.5 text-[11px] font-mono uppercase tracking-[0.2em] text-white/50">{label}</div>
      <input
        data-testid={testId}
        type={type}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-ink-200 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/30 outline-none focus:border-gold-500/50"
      />
    </div>
  );
}
